<template>
	<!-- <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/login/login">login</router-link>
    <button @click="onclick">控制台打印设备信息</button>
    <button @click="controlDevice">远程控制</button>
    <button @click="stopControl">停止远程控制</button>
    <button @click="startServer('ac68cf75',-1)">启动android服务端</button>
    <button @click="stopServer('ac68cf75',30540)">停止android服务端</button>
    <p>{{messages}} </p>
    <P>{{deviceinfo.lists }}</P>


  </div> -->
	<div id="app">
		<div id="nav" :style="{'top':(windowWidth>1700?'100px':'60px')}" >

		</div>
		<!-- <p>{{deviceinfo.lists }}</p> -->
		<router-view />
	</div>

</template>

<script>
	import {
		toRefs,
		reactive,
		onMounted
	} from 'vue';

	export default {
		setup() {
			const data = reactive({
				windowWidth: 0
			});

			onMounted(() => {
				data.windowWidth = document.documentElement.clientWidth;
				window.onresize = () => {
					data.windowWidth = document.documentElement.clientWidth;
				}
			});

			return {
				...toRefs(data),
			};
		},
	}
</script>

<style lang="less">
	#app {
		min-width: 1000px;
		font-family: "\5FAE\8F6F\96C5\9ED1";
		font-size: 12px;
		// min-width: 1000px;
		color: #333;
		-webkit-overflow-scrolling: touch;
		overflow-scrolling: touch;
		touch-action: none;
		background: #f9f9f9;
		position: relative;
	}
	#nav{
		position: fixed;
		top: 100px;
		right: 30px;
		z-index: 999;
	}
</style>
